import React from "react";
import stylesPc from "./HeaderLogo.module.css";
import stylesSp from "./HeaderLogo_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { Link, useLocation } from "react-router-dom";
import CineonhubLogo from "../../../../assets/image/cineonhubIcon";
import CineonstudioLogo from "../../../../assets/image/cineonstudioIcon";

export function HeaderLogo() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const { pathname } = useLocation();

    return (
        <h1 className={styles.h1}>
            {pathname.startsWith("/studio/") ? (
                // cineonstudio
                <Link to="/studio/homepage" className={styles.studioLogo}>
                    <CineonstudioLogo />
                </Link>
            ) : (
                // cineonhub
                <Link to="/homepage" className={styles.hubLogo}>
                    <CineonhubLogo />
                </Link>
            )}
        </h1>
    );
}
